import {createContext, use} from 'react'
import {EstablishedAhpSessionSnapshotContext} from '@github-ui/copilot-shared-ui/contexts/EstablishedAhpSessionContext'

// Keep creation scoped to the mounted conversation, not the transient startup
// record. Reopening the task later must still load its saved history.
export const NewTaskContext = createContext<string | undefined>(undefined)

export function useTaskHistoryRequired(taskId: string | undefined): boolean {
  const newTaskId = use(NewTaskContext)
  const snapshot = use(EstablishedAhpSessionSnapshotContext)
  // Reconnect snapshots can omit older turns even in a conversation created here.
  return !newTaskId || newTaskId !== taskId || snapshot?.state?.turnsNextCursor !== undefined
}
